import { QueryBuilder } from '@knitiv/api-client-javascript';
import { BaseController } from '~/utils/base-controller';

export class FastImportService extends BaseController {
	/* @ngInject */
	constructor(
		$injector,
	) {
		super($injector);

		this.fastImports = [];
	}

	// --- Functions ------------------------------------------------------------

	async fetch(force = false) {
		if (this.fastImports.length === 0 || force) {
			/** @type {QueryBuilder<'fastImport'>} */
			const widgetBuilder = this.api.createQueryBuilder();
			widgetBuilder
				.select(select => select
					.addColumn(column => column
						.as('fastImport')
						.withTarget('K_NODE;KSYSFASTIMPORT'),
					),
				)
				.from(from => from.addElement('K_NODE;KSYSFASTIMPORT'));

			const response = await widgetBuilder.fetchAll();

			this.fastImports = response.resolved().rows.map(row => ({
				fastImport: row.fastImport[0],
			}));
		}
		return this.fastImports;
	}
}
